import useBusiness from './api-hooks/useBusiness'
import useNotificationSettings from './api-hooks/useNotificationSettings'
import useQueues from './api-hooks/useQueues'
import useCustomFields from './api-hooks/useCustomFields'
import useWaitTimesByLocationId from './api-hooks/useWaitTimesByLocationId'
import useSelectedLocation from './api-selected-hooks/useSelectedLocation'
import useWaitlists from './api-hooks/useWaitlists'
import useSelfCheckIns from './api-hooks/useSelfCheckIns'
import useLocations from './api-hooks/useLocations'
import useVirtualWaitingRooms from './api-hooks/useVirtualWaitingRooms'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function useSettingsMutations() {
  const router = useRouter()
  const { mutateBusiness } = useBusiness()
  const { mutateNotificationSettings } = useNotificationSettings()
  const { mutateQueues } = useQueues()
  const { mutateCustomFields } = useCustomFields()
  const { locationId } = useSelectedLocation()
  const { mutateWaitTimes } = useWaitTimesByLocationId(locationId)
  const { mutateSelfCheckIns } = useSelfCheckIns()
  const { mutateLocations } = useLocations()
  const { mutateVirtualWaitingRooms } = useVirtualWaitingRooms()
  const { mutateWaitlists } = useWaitlists()

  const revalidateGeneralSettings = () => {
    mutateBusiness()
  }

  const revalidateNotificationSettings = () => {
    mutateNotificationSettings()
    mutateBusiness()
  }

  const revalidateQueuesSettings = () => {
    mutateCustomFields()
    mutateQueues()
    mutateWaitTimes()
  }

  const revalidateCustomFieldsSettings = () => {
    mutateCustomFields()
    mutateQueues()
  }

  const revalidateBookingsSettings = () => {
    mutateBusiness()
    mutateLocations()
    mutateNotificationSettings()
  }

  const revalidateSciSettings = () => {
    mutateSelfCheckIns()
  }

  const revalidateVwrSettings = () => {
    mutateVirtualWaitingRooms()
  }

  const revalidatePublicWaitlistSettings = () => {
    mutateWaitlists()
  }

  const revalidateSettingsPath = (path: string) => {
    switch (path) {
      case '/settings/general':
        revalidateGeneralSettings()
        break
      case '/settings/notifications':
        revalidateNotificationSettings()
        break
      case '/settings/queues':
        revalidateQueuesSettings()
        break
      case '/settings/custom-fields':
        revalidateCustomFieldsSettings()
        break
      case '/settings/bookings':
        revalidateBookingsSettings()
        break
      case '/settings/self-check-in':
        revalidateSciSettings()
        break
      case '/settings/virtual-waiting-rooms':
        revalidateVwrSettings()
        break
      case '/settings/public-waitlist':
        revalidatePublicWaitlistSettings()
        break
      default:
        return
    }
  }

  useEffect(() => {
    revalidateSettingsPath(router.pathname)
  }, [router.pathname])

  return {
    revalidateGeneralSettings,
  }
}
